module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "related-data"
  }, _vm._l((_vm.productList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "product-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/s-mart/application/' + item.app_id + '/detail'
        },
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "product-detail"
    }, [_c('div', {
      staticClass: "product-left"
    }, [_c('img', {
      attrs: {
        "src": item.feature_logo,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product-right"
    }, [_c('div', {
      staticClass: "right-title"
    }, [_vm._v(_vm._s(item.nick_name))]), _vm._v(" "), _c('div', {
      staticClass: "right-attention"
    }, [_c('el-rate', {
      staticClass: "star-rate",
      attrs: {
        "disabled": true,
        "void-icon-class": "el-icon-star-on",
        "disabled-void-color": "#c4c6cc",
        "colors": ['#fe9c00', '#fe9c00', '#fe9c00']
      },
      model: {
        value: (item.star),
        callback: function($$v) {
          _vm.$set(item, "star", $$v)
        },
        expression: "item.star"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "icon"
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.fan_num ? '取消收藏' : '添加收藏',
        "placement": "top"
      }
    }, [_c('i', {
      class: ['bk-icon icon-heart', {
        'icon-heart-shape': item.fan_num
      }]
    })]), _vm._v("\n                  " + _vm._s(item.fan_num) + "\n                ")], 1), _vm._v(" "), _c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "bk-icon icon-download"
    }), _vm._v(_vm._s(item.download_num) + "\n                ")])], 1)]), _vm._v(" "), (item.money_type == 3) ? _c('img', {
      staticClass: "inquiry",
      attrs: {
        "src": require("../../images/application_detail/inquiry.png")
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "product-desc"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.tip)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product-footer"
    }, [_c('img', {
      staticClass: "blue-whale-logo",
      attrs: {
        "src": require("../../images/application_detail/blue-whale-logo.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', [_c('span', [_vm._v("当前版本 : ")]), _vm._v(" "), _c('span', [_vm._v("V1.0.0")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("更新时间 : ")]), _vm._v(" "), _c('span', [_vm._v("2020-01-31")])])])])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4f427c19!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application/related_data.vue
// module id = fBaW
// module chunks = 15